module.exports = __webpack_public_path__ + "static/img/02.7217e98.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/04/02.jpg
// module id = voEs
// module chunks = 0